import { CrmSystemIds } from '@/features/crm_system/lib/_core/crmSystem/crmSystem.types.gen';
import { Tables } from '@/lib/supabase/supabase_types_override';
import { supabase } from '@/lib/supabase/supabaseClient';

export type OrganizationCrmConnectionItem = {
  crm: Tables<'crm'>[];
  crmProject: Tables<'crm_project'>[];
  crmConfig: Tables<'crm_config'>[];
  project: Tables<'project'>[];
  survey: Tables<'survey'>[];
  question: Tables<'question'>[];
};

export async function getOrganizationCrmConnectionsItems(
  orgId: Tables<'organisation'>['id']
) {
  // Get all CRMs for the organization with their crm_system
  const crms = await supabase
    .from('organisation_crm')
    .select(
      `
      crm_id,
      crm!inner(
        *,
        crm_project(
          *,
          crm_config(
            *
          ),
          project(
            *,
            survey(
              *,
              question(
                *
              )
            )
          )
        )
      )
`
    )
    .eq('organisation_id', orgId)
    .throwOnError()
    .then(({ data }) =>
      data?.reduce((acc, curr) => {
        if (!curr.crm) return acc;

        const crmSystemId = curr.crm.crm_system;
        const existing = acc.get(crmSystemId);

        // Extract all nested data
        const crmProjects = curr.crm.crm_project || [];
        const crmConfigs = crmProjects.flatMap((cp) => cp.crm_config || []);
        const projects = crmProjects.flatMap((cp) => cp.project || []);
        const surveys = projects.flatMap((p) => p.survey || []);
        const questions = surveys.flatMap((s) => s.question || []);

        if (existing) {
          // Append to existing arrays
          existing.crm.push(curr.crm);
          existing.crmProject.push(...crmProjects);
          existing.crmConfig.push(...crmConfigs);
          existing.project.push(...projects);
          existing.survey.push(...surveys);
          existing.question.push(...questions);
        } else {
          // Create new entry for this crmSystem
          acc.set(crmSystemId, {
            crm: [curr.crm],
            crmProject: crmProjects,
            crmConfig: crmConfigs,
            project: projects,
            survey: surveys,
            question: questions,
          });
        }

        return acc;
      }, new Map<CrmSystemIds, OrganizationCrmConnectionItem>())
    );

  return crms;
}
